import { render, staticRenderFns } from "./GoPageDetail.vue?vue&type=template&id=691d2e4e"
import script from "./GoPageDetail.vue?vue&type=script&lang=js"
export * from "./GoPageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports